var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"basicMapbox",style:(_vm.mapSize),attrs:{"id":_vm.fieldkey + '_map'}})
}
var staticRenderFns = []

export { render, staticRenderFns }